// extracted by mini-css-extract-plugin
export var externalLink = "_c8-0";
export var internalLinkLabel = "_c8-1";